(function () {
  const WORKER_URL = "https://homedelivery-proxy.twinovo-order-validator.workers.dev";

  const ESTADO_COLORES = {
    "pre registrado":        "#16a34a",
    "registrado":            "#16a34a",
    "en bodega crossdock":   "#16a34a",
    "en reparto":            "#16a34a",
    "en tránsito destino":   "#16a34a",
    "en transito destino":   "#16a34a",
    "en destino":            "#16a34a",
    "entregado":             "#16a34a",
    "excepción de entrega":  "#f59e0b",
    "excepcion de entrega":  "#f59e0b",
    "reingreso":             "#f59e0b",
    "reenvío a cliente":     "#f59e0b",
    "reenvio a cliente":     "#f59e0b",
    "fallo de entrega":      "#dc2626",
    "en custodia":           "#dc2626",
    "retorno seller":        "#dc2626",
    "anulado":               "#dc2626",
  };

  const COLOR_RETIRO = {
    "verde":    "#16a34a",
    "amarillo": "#f59e0b",
    "rojo":     "#dc2626",
  };

  function getColorHD(estado) {
    if (!estado) return "#d1d5db";
    return ESTADO_COLORES[estado.toLowerCase().trim()] || "#d1d5db";
  }

  const styles = `
    #hd-tracker {
      font-family: inherit;
      max-width: 560px;
      margin: 0;
      margin-inline: auto;
      margin-top: 2.5rem;
    }
    #hd-tracker .hd-search {
      display: flex;
      gap: 8px;
      margin-bottom: 1.5rem;
    }
    #hd-tracker input {
      flex: 1;
      padding: 10px 14px;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      font-size: 14px;
      outline: none;
      transition: border-color 0.2s;
    }
    #hd-tracker input:focus { border-color: #000; }
    #hd-tracker button {
      padding: 10px 20px;
      background: #000;
      color: #fff;
      border: none;
      border-radius: 6px;
      font-size: 14px;
      cursor: pointer;
      transition: background 0.2s;
    }
    #hd-tracker button:hover { background: #333; }
    #hd-tracker button:disabled { background: #9ca3af; cursor: not-allowed; }
    #hd-tracker .hd-error {
      padding: 12px 16px;
      background: #fef2f2;
      border: 1px solid #fca5a5;
      border-radius: 6px;
      color: #b91c1c;
      font-size: 14px;
    }
    #hd-tracker .hd-timeline {
      position: relative;
      padding-left: 28px;
    }
    #hd-tracker .hd-timeline::before {
      content: '';
      position: absolute;
      left: 7px;
      top: 8px;
      bottom: 8px;
      width: 2px;
      background: #e5e7eb;
    }
    #hd-tracker .hd-step {
      position: relative;
      margin-bottom: 1.25rem;
    }
    #hd-tracker .hd-step:last-child { margin-bottom: 0; }
    #hd-tracker .hd-dot {
      position: absolute;
      left: -27px;
      top: 4px;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      border: 2px solid #fff;
    }
    #hd-tracker .hd-estado {
      font-weight: 600;
      font-size: 14px;
    }
    #hd-tracker .hd-descripcion {
      font-size: 13px;
      color: #6b7280;
      margin-top: 2px;
    }
    #hd-tracker .hd-lugar {
      font-size: 13px;
      color: #6b7280;
      margin-top: 2px;
    }
    #hd-tracker .hd-fecha {
      font-size: 12px;
      color: #727884;
      margin-top: 2px;
    }
    #hd-tracker .hd-spinner {
      text-align: center;
      padding: 2rem;
      color: #6b7280;
      font-size: 14px;
    }
  `;

  function formatFecha(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    return d.toLocaleString("es-PE", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit"
    });
  }

  function renderTimelineHD(pasos) {
    return pasos.map((paso) => {
      const color = getColorHD(paso.estado);
      return `
        <div class="hd-step">
          <div class="hd-dot" style="background:${color}; box-shadow: 0 0 0 2px ${color};"></div>
          <div class="hd-estado" style="color:${color}">${paso.estado}</div>
          <div class="hd-fecha">${formatFecha(paso.fecha)}</div>
        </div>
      `;
    }).join("");
  }

  function renderTimelineRetiro(pasos) {
    return pasos.map((paso) => {
      const color = COLOR_RETIRO[paso.color] || "#d1d5db";
      return `
        <div class="hd-step">
          <div class="hd-dot" style="background:${color}; box-shadow: 0 0 0 2px ${color};"></div>
          <div class="hd-estado" style="color:${color}">${paso.estado}</div>
          <div class="hd-descripcion">${paso.descripcion}</div>
          <div class="hd-fecha">${formatFecha(paso.fecha)}</div>
        </div>
      `;
    }).join("");
  }

  function normalizarNumero(input) {
    return input.trim().replace(/^#/, "").toUpperCase();
  }

  async function buscarPedido(numero, resultDiv, btn) {
    numero = normalizarNumero(numero);
    resultDiv.innerHTML = `<div class="hd-spinner">Consultando...</div>`;
    btn.disabled = true;

    try {
      const res = await fetch(
        `${WORKER_URL}/trazabilidad?numero_seguimiento=${encodeURIComponent(numero)}`
      );
      const data = await res.json();

      if (!data.success) {
        resultDiv.innerHTML = `<div class="hd-error">${data.message || "No se encontró el pedido."}</div>`;
        return;
      }

      const pasos = data.data || [];
      if (pasos.length === 0) {
        resultDiv.innerHTML = `<div class="hd-error">No hay eventos registrados para este pedido.</div>`;
        return;
      }

      if (data.tipo === "retiro_en_tienda" || data.tipo === "despacho" || data.tipo === "cancelado") {
        resultDiv.innerHTML = `<div class="hd-timeline">${renderTimelineRetiro(pasos)}</div>`;
      } else {
        resultDiv.innerHTML = `<div class="hd-timeline">${renderTimelineHD(pasos)}</div>`;
      }

    } catch (e) {
      resultDiv.innerHTML = `<div class="hd-error">Error de conexión. Intenta nuevamente.</div>`;
    } finally {
      btn.disabled = false;
    }
  }

  function init() {
    const container = document.getElementById("hd-tracker");
    if (!container) return;

    const styleEl = document.createElement("style");
    styleEl.textContent = styles;
    document.head.appendChild(styleEl);

    container.innerHTML = `
      <div class="hd-search">
        <input type="text" id="hd-input" placeholder="Número de seguimiento" />
        <button id="hd-btn">Rastrear</button>
      </div>
      <div id="hd-result"></div>
    `;

    const input = document.getElementById("hd-input");
    const btn = document.getElementById("hd-btn");
    const result = document.getElementById("hd-result");

    btn.addEventListener("click", () => {
      const val = input.value.trim();
      if (!val) return;
      buscarPedido(val, result, btn);
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") btn.click();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();